// frontend/src/components/CustomConfirmDialog.js
// Componente de diálogo de confirmación personalizado.
// Reemplaza la función window.confirm().

import React from 'react';

/**
 * @component CustomConfirmDialog
 * @description Muestra un modal de diálogo para pedir confirmación al usuario.
 * @param {object} props - Propiedades del componente.
 * @param {boolean} props.show - Si el diálogo debe mostrarse (true) u ocultarse (false).
 * @param {string} props.message - El mensaje a mostrar en el diálogo.
 * @param {function} props.onConfirm - Callback que se ejecuta cuando el usuario confirma.
 * @param {function} props.onCancel - Callback que se ejecuta cuando el usuario cancela.
 */
function CustomConfirmDialog({ show, message, onConfirm, onCancel }) {
  if (!show) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full">
        <p className="text-gray-800 text-lg mb-6 text-center">{message}</p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={onCancel}
            className="px-5 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="px-5 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
}

export default CustomConfirmDialog;
